import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { GeoAltFill, Whatsapp, EnvelopeFill } from "react-bootstrap-icons";
import { useTiendaConfig } from "../../../hooks/useTiendaConfig";
import getIcon from "../../../utils/getIcon";
import { useCompanyInfo } from "../../../hooks/useCompanyInfo";

const Contact = () => {
    const { socialLinks, whatsappLink } = useTiendaConfig();
    const { companyData } = useCompanyInfo();

    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(companyData.direccion)}`;
    const storeAddress = `${companyData.direccion} ${companyData.ciudad} - ${companyData.departamento}`;

    // Función para obtener URL de WhatsApp válida
    const getWhatsappUrl = () => {
        if (whatsappLink && typeof whatsappLink.url === 'string' && whatsappLink.url.trim() !== '') {
            return whatsappLink.url;
        }
        return '#';
    };

    return (
        <>
            {/* SVG de transición en forma de onda invertida */}
            <svg viewBox="0 -1 1440 320" className="wave-transition wave-transition-top" xmlns="http://www.w3.org/2000/svg">
                <path fill="#2b235e" fillOpacity="1" d="M0,96L40,90.7C80,85,160,75,240,106.7C320,139,400,213,480,213.3C560,213,640,139,720,128C800,117,880,171,960,202.7C1040,235,1120,245,1200,240C1280,235,1360,213,1400,202.7L1440,192L1440,320L1400,320C1360,320,1280,320,1200,320C1120,320,1040,320,960,320C880,320,800,320,720,320C640,320,560,320,480,320C400,320,320,320,240,320C160,320,80,320,40,320L0,320Z"></path>
            </svg>
            <div style={{ backgroundColor: '#2b235e' }} className="py-5">
                <Container>
                    {/* Título */}
                    <div className="text-center mb-5">
                        <h2 className="text-uppercase text-danger mb-3 fs-6 fw-bold">Contacto</h2>
                        <h3 className="fw-bold text-white fs-2">¿Tienes preguntas? ¡Escríbenos!</h3>
                        <p className="text-white-50 mt-3 mx-auto" style={{ maxWidth: '600px' }}>
                            Estamos disponibles para ayudarte. Contáctanos por cualquiera de nuestros canales.
                        </p>
                    </div>

                    {/* Redes Sociales */}
                    <div className="text-center mb-5">
                        <p className="text-white-50 mb-3">Síguenos en nuestras redes sociales</p>
                        <div className="d-flex justify-content-center gap-3">
                            {socialLinks.map((link, index) => (
                                <a
                                    key={index}
                                    href={link.url}
                                    rel='noreferrer noopener'
                                    target="_blank"
                                    title={link.title}
                                    className="d-flex align-items-center justify-content-center"
                                    style={{
                                        width: '50px',
                                        height: '50px',
                                        borderRadius: '50%',
                                        backgroundColor: 'rgba(255,255,255,0.1)',
                                        transition: 'all 0.3s ease'
                                    }}
                                >
                                    <span className="text-white fs-5">{getIcon(link.url)}</span>
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Información de Contacto */}
                    <Row className="g-4 justify-content-center">
                        {/* Dirección */}
                        <Col md={4} lg={3}>
                            <Card
                                className="h-100 border-0 shadow-lg"
                                style={{ borderRadius: '16px', backgroundColor: 'rgba(255,255,255,0.1)' }}
                            >
                                <Card.Body className="text-center text-white p-4">
                                    <div
                                        className="d-inline-flex align-items-center justify-content-center mb-3"
                                        style={{
                                            width: '60px',
                                            height: '60px',
                                            borderRadius: '50%',
                                            backgroundColor: '#dc3545'
                                        }}
                                    >
                                        <GeoAltFill size={28} className="text-white" />
                                    </div>
                                    <Card.Title className="fw-bold mb-2">Dirección</Card.Title>
                                    <Card.Text className="text-white-50 small mb-3">
                                        {storeAddress}
                                    </Card.Text>
                                    <Button
                                        variant="danger"
                                        size="sm"
                                        href={googleMapsUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Ver en mapa
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* WhatsApp */}
                        <Col md={4} lg={3}>
                            <Card
                                className="h-100 border-0 shadow-lg"
                                style={{ borderRadius: '16px', backgroundColor: 'rgba(255,255,255,0.1)' }}
                            >
                                <Card.Body className="text-center text-white p-4">
                                    <div
                                        className="d-inline-flex align-items-center justify-content-center mb-3"
                                        style={{
                                            width: '60px',
                                            height: '60px',
                                            borderRadius: '50%',
                                            backgroundColor: '#dc3545'
                                        }}
                                    >
                                        <Whatsapp size={28} className="text-white" />
                                    </div>
                                    <Card.Title className="fw-bold mb-2">WhatsApp</Card.Title>
                                    <Card.Text className="text-white-50 small mb-3">
                                        Unete a nuestro Grupo Mayorista
                                    </Card.Text>
                                    <Button
                                        variant="danger"
                                        size="sm"
                                        href={getWhatsappUrl()}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Enviar mensaje
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Correo */}
                        <Col md={4} lg={3}>
                            <Card
                                className="h-100 border-0 shadow-lg"
                                style={{ borderRadius: '16px', backgroundColor: 'rgba(255,255,255,0.1)' }}
                            >
                                <Card.Body className="text-center text-white p-4">
                                    <div
                                        className="d-inline-flex align-items-center justify-content-center mb-3"
                                        style={{
                                            width: '60px',
                                            height: '60px',
                                            borderRadius: '50%',
                                            backgroundColor: '#dc3545'
                                        }}
                                    >
                                        <EnvelopeFill size={28} className="text-white" />
                                    </div>
                                    <Card.Title className="fw-bold mb-2">Correo</Card.Title>
                                    <Card.Text className="text-white-50 small mb-3">
                                        Correo corporativo para consultas empresariales.
                                    </Card.Text>
                                    <Button
                                        variant="danger"
                                        size="sm"
                                        href={`mailto:${companyData.email}`}
                                    >
                                        Enviar correo
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
};

export default Contact;
